module.exports = __webpack_public_path__ + "static/media/vitor.3d4449ff.png";